import React from "react";
import * as Ant from "antd";
import {PopoverProps} from "antd/lib/popover";
import constants from "../../constants/constants";

export function Popover(props: PopoverProps) {
    return <Ant.Popover {...props} getPopupContainer={() => document.getElementById(constants.Content)!} />
}